/* ============
 * Order Event Transformer
 * ============
 */

import Transformer from './transformer';

export default class OrderEventTransformer extends Transformer {

  static fetch(e) {
    return {
      id: e.id,
      events: e.events,
      orderId: e.order_id,
      descriptions: e.descriptions,
      status: e.status,
      order: e.order,
      createdAt: e.created_at,
    };
  }

  static send(e) {
    return {
      id: e.id,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/orderEvent.js